import React, { useState, useEffect } from "react";
import { useNavigate, Routes, Route, Link, Navigate, Outlet } from "react-router-dom";
import { auth } from "../firebaseConfig";
import { signOut } from "firebase/auth";

// Placeholder components for each section
const RegisteredPlayers = () => (
  <div className="p-4">
    <h2 className="text-2xl font-bold mb-4">Registered Players</h2>
    <div className="bg-gray-50 p-4 rounded-lg">
      <p>Registered Players content will be displayed here</p>
    </div>
  </div>
);

const CashRequests = () => (
  <div className="p-4">
    <h2 className="text-2xl font-bold mb-4">Cash Requests</h2>
    <div className="bg-gray-50 p-4 rounded-lg">
      <p>Cash Requests content will be displayed here</p>
    </div>
  </div>
);

const CashApprovals = () => (
  <div className="p-4">
    <h2 className="text-2xl font-bold mb-4">Cash Approvals</h2>
    <div className="bg-gray-50 p-4 rounded-lg">
      <p>Cash Approvals content will be displayed here</p>
    </div>
  </div>
);

const CashPending = () => (
  <div className="p-4">
    <h2 className="text-2xl font-bold mb-4">Cash Pending</h2>
    <div className="bg-gray-50 p-4 rounded-lg">
      <p>Cash Pending content will be displayed here</p>
    </div>
  </div>
);

const AdminDashboard = ({ projectName = "Admin Portal" }) => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("registered-players");
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        setUser(currentUser);
      } else {
        navigate("/admin-login");
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const menuItems = [
    { label: "Registered Players", value: "registered-players" },
    { label: "Cash Requests", value: "cash-requests" },
    { label: "Cash Approvals", value: "cash-approvals" },
    { label: "Cash Pending", value: "cash-pending" },
  ];

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/admin-login");
    } catch (error) {
      console.error("Error signing out:", error);
      alert("Failed to log out. Please try again.");
    }
  };

  if (!user) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
          <h1 className="text-2xl font-bold text-gray-900">{projectName}</h1>
        </div>
      </header>

      <div className="flex flex-1">
        <aside className="hidden md:flex md:w-64 bg-indigo-700 text-white p-4 flex-col">
          {menuItems.map((item) => (
            <Link
              key={item.value}
              to={item.value}
              className={`${
                activeSection === item.value ? "bg-indigo-800" : "bg-indigo-500"
              } hover:bg-indigo-600 text-white font-semibold py-2 px-4 rounded mb-4 transition-colors`}
              onClick={() => setActiveSection(item.value)}
            >
              {item.label}
            </Link>
          ))}
          <button
            className="mt-auto bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded transition-colors"
            onClick={handleLogout}
          >
            Logout
          </button>
        </aside>

        <div className="flex-1 bg-white p-6 shadow-inner overflow-auto">
          <Routes>
            <Route path="/" element={<Navigate to="registered-players" replace />} />
            <Route path="registered-players" element={<RegisteredPlayers />} />
            <Route path="cash-requests" element={<CashRequests />} />
            <Route path="cash-approvals" element={<CashApprovals />} />
            <Route path="cash-pending" element={<CashPending />} />
          </Routes>
        </div>
      </div>

      <nav className="md:hidden fixed bottom-0 left-0 w-full bg-indigo-700 text-white flex flex-col items-stretch p-4 shadow-lg">
        {menuItems.map((item) => (
          <Link
            key={item.value}
            to={item.value}
            className={`${
              activeSection === item.value ? "bg-indigo-800" : "bg-indigo-500"
            } hover:bg-indigo-600 text-white font-semibold py-2 px-4 rounded mb-2 transition-colors`}
            onClick={() => setActiveSection(item.value)}
          >
            {item.label}
          </Link>
        ))}
        <button
          className="bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded transition-colors"
          onClick={handleLogout}
        >
          Logout
        </button>
      </nav>

      <footer className="bg-gray-800 text-white text-center py-4">
        <div>© {new Date().getFullYear()} {projectName}. All rights reserved.</div>
        <div className="flex justify-center space-x-4 mt-2">
          <button
            className="text-blue-400 hover:underline"
            onClick={() => navigate("/privacy-policy")}
          >
            Privacy Policy
          </button>
          <button
            className="text-blue-400 hover:underline"
            onClick={() => navigate("/terms-and-conditions")}
          >
            Terms and Conditions
          </button>
        </div>
      </footer>
    </div>
  );
};

export default AdminDashboard;